@if (!isOldIos) {
  <router-outlet />

  <div
    class="landscape-warning"
    [class.landscape-warning--visible]="isLandscape()">
    <div>
      <fu-icon iconName="mobile-cancel" size="96" />
      <h2>{{ 'common.landscapeLock.title' | translate }}</h2>
      <p>
        {{ 'common.landscapeLock.portraitOnly.text' | translate }}
        <br />
        {{ 'common.landscapeLock.rotateBack.text' | translate }}
      </p>
    </div>
  </div>
} @else {
  <p>Some features may not work as expected. Please update your device.</p>
}
